/* 筛选按钮<el-popover
  placement="bottom"
  width="300"
  v-model="popoverVisible">
  <el-checkbox-group v-model="propList">
    <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
  </el-checkbox-group>
  <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
</el-popover> */

/* 循环列<el-table-column
  :label="item.label"
  :prop="item.prop"
  :min-width="item.width"
  :sortable="item.sortable ? 'custom' : false"
  show-overflow-tooltip
  v-for="item in sortedPropList" :key="item.prop"
>
  <template slot-scope="scope">
    <template>
      {{scope.row[item.prop]}}
    </template>
  </template>
</el-table-column> */

// 导出
// const loading = this.$loading({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// });
// let params = {
//   taskDTO: {
//     appCode: "ec-pc-api",
//     // 数据过滤
//     paramMap: {
//       exportTag: true,
//       ...this.searchForm.filterData
//     },
//     reportName: "skuExport"
//   },
//   // 配置导出列
//   columnDTOs: [
//     // {
//     //   columnName: '包件编码',
//     //   parentColumnName: null,
//     //   fieldName: 'packCode',
//     //   fieldType: 'string',
//     //   columnFormat: null
//     // }
//   ]
// };
// let labels = this.sortedPropList.map(v=>v.label);
// let props = this.sortedPropList.map(v=>v.prop);
// props.forEach((prop, index) => {
//   params.columnDTOs.push({
//     columnName: labels[index],
//     parentColumnName: null,
//     fieldName: prop,
//     fieldType: 'string',
//     columnFormat: null
//   })
// })
// // 不导出图片列
// params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
// this.$q.common.customExportExcel({data: params}).then((res) => {
//   console.log(res)
//   loading.close();
//   this.$message({
//     type: "success",
//     message: "导出成功,请在导出列表中查看",
//   });
// });
export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'delistAnalyseReport',
      tableVisible: false,
      tableReload: true
    }
  },
  mounted() {
    this.columns()
  },
  methods: {
    columns(type) {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.columnsData = res.data
        let data = res.data.userColumns.length ? res.data.userColumns : res.data.sysColumns
        let list = []
        data.forEach(v => {
          list.push({
            displayName: v.displayName,
            displayWidth: v.displayWidthNum,
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.columnName
          })
        });
        this.tableDataSet = list
        if(!type) {
          this.customColumn(this.columnsData)
        }
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns(true)
    },
    confirm() {
      let data = []
      console.log(this.tableDataSet);
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: v.displayWidth,
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
    async customColumn(data) {
      if (data.userColumns.length) {
        data = data.userColumns.filter(v=>!v.isShow)
      } else {
        data = data.sysColumns
      }
      this.columnData = data
    }
  }
}